import { unwrapResult } from '@reduxjs/toolkit'
import { API_CONFIG, API_LIST } from '../../Constants/ApiDefinations'
import { downloadDataInCSV } from '../../Helpers/Util'
import mainApiService from '../../Services'
import { showAlert } from '../../Store/Slice/alert.slice'
import {
  categoryListService,
  setCloneAssetDefinition,
} from '../../Store/Slice/asset-definition.slice'
import AssetCloneIcon from '../Icons/AssetCloneIcon'
import { DownloadIcon } from '../Icons/PlayListPlay'
import MUITooltip from '../Shared/MUI-Tooltip'

import { PERMISSIONS, PERMISSION_TYPE, checkPermission } from '../../Helpers/Permission'

export const assetDefinitionListingAction = (
  assetDefination: any,
  dispatch: any,
  setLoader: any,
  cmsConfig?: any,
) => {
  const hasWritePermission = checkPermission(PERMISSIONS.META_MASTER_ASSET_DEFINITION, [
    PERMISSION_TYPE.CAN_WRITE,
  ])

  const handleDownloadAssetDefination = async (event: React.MouseEvent) => {
    dispatch(setLoader(true))
    event.preventDefault()
    event.stopPropagation()
    const reqPayload: any = API_CONFIG(API_LIST.ASSET_TYPE_DEFINITION.DOWNLOAD_ASSET_TYPE, null, {
      assetTypeId: assetDefination._id,
    })
    const res: any = await mainApiService(reqPayload)
    dispatch(setLoader(false))
    if (!res.error) {
      const { assetType, assetCategory, contentCategory } = assetDefination

      const formatText = (text: string) =>
        text
          .toLowerCase()
          .split('_')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join('_')

      const formattedAssetType = formatText(assetType)
      const formattedAssetCategory = formatText(assetCategory)
      const formattedContentCategory = formatText(contentCategory)

      const fileName = `${formattedAssetType}-${formattedAssetCategory}-${formattedContentCategory}.csv`
      downloadDataInCSV(res, fileName)
      dispatch(showAlert([true, 'Asset type definition downloaded successfully', 'success']))
    }
  }

  const handleCloneAssetDefination = async (event: React.MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()

    try {
      dispatch(setLoader(true))
      const [categories, assetDefinition] = await Promise.all([
        dispatch(categoryListService() as any),
        mainApiService(
          API_CONFIG(API_LIST.ASSET_TYPE_DEFINITION.VIEW_ASSET_TYPE, null, {
            assetDefinitionId: assetDefination._id,
          }),
        ),
      ])
      dispatch(setLoader(false))

      if (!assetDefinition.error) {
        const categoriesRes = unwrapResult(categories)
        const metaCategories = categoriesRes?.data?.map((item: any) => item.categoryKey) as string[]
        const allowedData = {
          ...assetDefinition.data,
          allowedParents: assetDefinition.data.allowedParents.map((item: any) => item._id),
        }
        dispatch(
          setCloneAssetDefinition({
            show: true,
            data: {
              metaCategories,
              ...allowedData,
            },
          }),
        )
      } else {
        dispatch(
          showAlert([
            true,
            assetDefinition.error.message || 'Failed to fetch asset definition',
            'error',
          ]),
        )
      }
    } catch (error) {
      dispatch(setLoader(false))
      dispatch(showAlert([true, 'An error occurred while fetching asset definition', 'error']))
    }
  }

  return (
    <span className='asset-defination-action'>
      {cmsConfig?.ENABLED_FEATURES?.ASSET_DEFINATION_EXPORT && (
        <MUITooltip title='Download Definition' disableInteractive>
          <span
            className='download-defination-icon'
            data-testid='download-defination-icon'
            onClick={handleDownloadAssetDefination}
          >
            <DownloadIcon />
          </span>
        </MUITooltip>
      )}
      {cmsConfig?.ENABLED_FEATURES?.ASSET_DEFINATION_CLONE && hasWritePermission && (
        <MUITooltip title='Clone Asset Type' disableInteractive>
          <span
            className='clone-defination-icon'
            data-testid='clone-defination-icon'
            onClick={handleCloneAssetDefination}
          >
            <AssetCloneIcon />
          </span>
        </MUITooltip>
      )}
    </span>
  )
}
